import styled from 'styled-components';
import { withStyles, InputLabel } from '@material-ui/core';
import SearchFieldComponent from '../../../../components/SearchField/SearchField';
import { constants, spacing, colours } from '@cambridgeassessment/cambridge-ui';

export const StyledInputLabel = withStyles({
  root: {
    color: colours.black,
    fontFamily: 'SourceSansPro',
    fontSize: constants.LARGE,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    marginBottom: spacing.tiny,
  },
})(InputLabel);

export const StyledSearchFieldComponent = styled(SearchFieldComponent)`
  width: 359px;
  height: 62px;
  font-family: SourceSansPro;
  font-size: ${constants.LARGE};
`;
